/**
 * Two initials, the way the mock's avatars read.
 *
 * Shared rather than duplicated: the contacts table, the queue panel and the
 * interaction drawer all draw the same avatar, and two contacts should not get
 * different initials depending on which page you are looking at.
 */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  return (
    parts
      .slice(0, 2)
      .map((part) => part[0]?.toUpperCase() ?? '')
      .join('') || '?'
  );
}
